import {
  my_routes,
  parent_routes,
  prof_routes,
  public_routes,
  student_routes,
} from "../../../feature-module/router/all_routes";
import {
  buildPermission,
  Resource,
  Action,
} from "../../common/autorisations/permissionsMap";

export const getSidebarData = (
  permissions: any[],
  userType: string | null,
  isSuperAdmin: boolean,
) => {
  const routes = my_routes;
  const public_route = public_routes;
  const student_route = student_routes;
  const prof_route = prof_routes;
  const parent_route = parent_routes;

  // les datas du sidebar
  const sidebarData = [];

  const dashboardLink = userType
    ? userType === "UserProfil"
      ? routes.adminDashboard
      : userType === "StudentProfil"
        ? student_route.studentDashboard
        : userType === "ParentProfil"
          ? parent_route.parentDashboard
          : prof_route.teacherDashboard
    : public_route.login;

  const userProfilSections: any[] = [
    ([
      // etudiant (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.STUDENT, action),
      ),

      // parent (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.PARENT, action),
      ),

      // professeur (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.TEACHER, action),
      ),

      // document (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.DOCUMENTATION, action),
      ),

      // niveau (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.LEVEL, action),
      ),

      // classe (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.CLASS, action),
      ),

      // matiere (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.SUBJECT, action),
      ),

      // salle de classe (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.CLASSROOM, action),
      ),
    ].some((p) => permissions.includes(p)) ||
      isSuperAdmin) && {
      label: "ACCUEIL",
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: "Peoples",
      submenuItems: [
        // map chaque actions avec la ressource et verifie si un de ces mappage est dans les permissions de l'utilisateur
        ([
          // etudiant (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
          ...Object.values(Action).map((action) =>
            buildPermission(Resource.STUDENT, action),
          ),

          // parent (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
          ...Object.values(Action).map((action) =>
            buildPermission(Resource.PARENT, action),
          ),

          // professeur (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
          ...Object.values(Action).map((action) =>
            buildPermission(Resource.TEACHER, action),
          ),

          // document (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
          ...Object.values(Action).map((action) =>
            buildPermission(Resource.DOCUMENTATION, action),
          ),

          // niveau (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
          ...Object.values(Action).map((action) =>
            buildPermission(Resource.LEVEL, action),
          ),

          // classe (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
          ...Object.values(Action).map((action) =>
            buildPermission(Resource.CLASS, action),
          ),

          // matiere (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
          ...Object.values(Action).map((action) =>
            buildPermission(Resource.SUBJECT, action),
          ),

          // salle de classe (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
          ...Object.values(Action).map((action) =>
            buildPermission(Resource.CLASSROOM, action),
          ),
        ].some((p) => permissions.includes(p)) ||
          isSuperAdmin) && {
          label: "UIE Online",
          icon: "ti ti-user-bolt",
          showSubRoute: false,
          submenu: false,
          link: routes.adminDashboard,
        },
      ].filter(Boolean),
    },
    // Finance et Comptabilité
    ([
      // bourse/remise (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.BOURSE_REMISE, action),
      ),

      // plan de paiement (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.PAYMENT_PLAN, action),
      ),

      // plan de paiement des étudiants (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.STUDENT_PAYMENT_PLAN, action),
      ),

      // paiement (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.PAYMENT, action),
      ),

      // paramètres de paiement (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.PAYMENT_SETTING, action),
      ),

      // restriction de note (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.NOTE_RESTRICTION, action),
      ),
    ].some((p) => permissions.includes(p)) ||
      isSuperAdmin) && {
      label: "Finance et Comptabilité",
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: "Peoples",
      submenuItems: [
        // map chaque actions avec la ressource et verifie si un de ces mappage est dans les permissions de l'utilisateur
        ([
          // bourse/remise (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
          ...Object.values(Action).map((action) =>
            buildPermission(Resource.BOURSE_REMISE, action),
          ),

          // plan de paiement (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
          ...Object.values(Action).map((action) =>
            buildPermission(Resource.PAYMENT_PLAN, action),
          ),

          // plan de paiement des étudiants (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
          ...Object.values(Action).map((action) =>
            buildPermission(Resource.STUDENT_PAYMENT_PLAN, action),
          ),

          // paiement (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
          ...Object.values(Action).map((action) =>
            buildPermission(Resource.PAYMENT, action),
          ),

          // paramètres de paiement (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
          ...Object.values(Action).map((action) =>
            buildPermission(Resource.PAYMENT_SETTING, action),
          ),

          // restriction de note (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
          ...Object.values(Action).map((action) =>
            buildPermission(Resource.NOTE_RESTRICTION, action),
          ),
        ].some((p) => permissions.includes(p)) ||
          isSuperAdmin) && {
          label: "Finance Online",
          icon: "ti ti-credit-card",
          showSubRoute: false,
          submenu: false,
          link: routes.financeHome,
        },
      ].filter(Boolean),
    },
    // Acteurs Académiques
    ([
      // document (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.DOCUMENTATION, action),
      ),

      ...Object.values(Action).map((action) =>
        buildPermission(Resource.FREQUENTATION, action),
      ),

      // rapport prof (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.TEACHER_REPORT, action),
      ),

      // visiteur (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.VISITOR, action),
      ),

      // memoire (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.MEMOIRE, action),
      ),

      // request/demande (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.REQUEST, action),
      ),

      // planning examen (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.EDTE, action),
      ),

      // reclamations (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.CLAIM, action),
      ),

      // messages (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.MESSAGE, action),
      ),
      // evenement (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.EVENT, action),
      ),
    ].some((p) => permissions.includes(p)) ||
      isSuperAdmin) && {
      label: "Acteurs Académiques",
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: "Peoples",
      submenuItems: [
        // map chaque actions avec la ressource et verifie si un de ces mappage est dans les permissions de l'utilisateur
        (Object.values(Action).some((action) =>
          permissions.includes(buildPermission(Resource.MESSAGE, action)),
        ) ||
          isSuperAdmin) && {
          label: "Messages",
          icon: "fa fa-envelope",
          showSubRoute: false,
          submenu: false,
          link: routes.messagePage,
        },

        // map chaque actions avec la ressource et verifie si un de ces mappage est dans les permissions de l'utilisateur
        ([
          // frequentation de classe (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
          ...Object.values(Action).map((action) =>
            buildPermission(Resource.FREQUENTATION, action),
          ),

          // emargement de classe (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
          ...Object.values(Action).map((action) =>
            buildPermission(Resource.EMARGEMENT, action),
          ),
        ].some((p) => permissions.includes(p)) ||
          isSuperAdmin) && {
          label: "Documentation",
          icon: "ti ti-files",
          submenu: false,
          showSubRoute: false,
          link: routes.docs,
          themeSetting: true,
        },
        //rapport mensuel (map chaque actions avec la ressource et verifie si un de ces mappage est dans les permissions de l'utilisateur)
        (Object.values(Action).some((action) =>
          permissions.includes(
            buildPermission(Resource.TEACHER_REPORT, action),
          ),
        ) ||
          isSuperAdmin) && {
          label: "Rapport Mensuel (Prof)",
          icon: "ti ti-calendar",
          showSubRoute: false,
          submenu: false,
          link: routes.teacherReport,
        },

        ([
          //visiteur (map chaque actions avec la ressource et verifie si un de ces mappage est dans les permissions de l'utilisateur)
          ...Object.values(Action).map((action) =>
            buildPermission(Resource.VISITOR, action),
          ),
        ].some((p) => permissions.includes(p)) ||
          isSuperAdmin) && {
          label: "Visiteurs",
          icon: "ti ti-users",
          showSubRoute: false,
          submenu: false,
          link: routes.visitorList,
        },

        ([
          //memoire (map chaque actions avec la ressource et verifie si un de ces mappage est dans les permissions de l'utilisateur)
          ...Object.values(Action).map((action) =>
            buildPermission(Resource.MEMOIRE, action),
          ),
        ].some((p) => permissions.includes(p)) ||
          isSuperAdmin) && {
          label: "Memoires",
          icon: "ti ti-book",
          showSubRoute: false,
          submenu: false,
          link: routes.memoryList,
        },

        ([
          //demandes (map chaque actions avec la ressource et verifie si un de ces mappage est dans les permissions de l'utilisateur)
          ...Object.values(Action).map((action) =>
            buildPermission(Resource.REQUEST, action),
          ),
        ].some((p) => permissions.includes(p)) ||
          isSuperAdmin) && {
          label: "Demandes",
          icon: "fa fa-flag-checkered",
          showSubRoute: false,
          submenu: false,
          link: routes.requestList,
        },

        ([
          //memoire (map chaque actions avec la ressource et verifie si un de ces mappage est dans les permissions de l'utilisateur)
          ...Object.values(Action).map((action) =>
            buildPermission(Resource.EDTE, action),
          ),
        ].some((p) => permissions.includes(p)) ||
          isSuperAdmin) && {
          label: "Planning des Examens",
          icon: "ti ti-book",
          showSubRoute: false,
          submenu: false,
          link: routes.planingExam,
        },

        ([
          //reclamations (map chaque actions avec la ressource et verifie si un de ces mappage est dans les permissions de l'utilisateur)
          ...Object.values(Action).map((action) =>
            buildPermission(Resource.CLAIM, action),
          ),
        ].some((p) => permissions.includes(p)) ||
          isSuperAdmin) && {
          label: "Réclamations",
          icon: "fa fa-sign-language",
          showSubRoute: false,
          submenu: false,
          link: routes.claimList,
        },

        ([
          //evenements (map chaque actions avec la ressource et verifie si un de ces mappage est dans les permissions de l'utilisateur)
          ...Object.values(Action).map((action) =>
            buildPermission(Resource.EVENT, action),
          ),
        ].some((p) => permissions.includes(p)) ||
          isSuperAdmin) && {
          label: "Gestion des évenements",
          icon: "fa fa-calendar",
          showSubRoute: false,
          submenu: false,
          link: routes.eventPage,
        },
      ].filter(Boolean),
    },
    // Gestion des Notes
    ([
      // notes (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.NOTE, action),
      ),

      // UE (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.UE, action),
      ),

      // matières (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.SUBJECT, action),
      ),

      // diplomes (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.DIPLOME, action),
      ),
    ].some((p) => permissions.includes(p)) ||
      isSuperAdmin) && {
      label: "Gestion des Notes",
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: "Peoples",
      submenuItems: [
        // map chaque actions avec la ressource et verifie si un de ces mappage est dans les permissions de l'utilisateur
        (Object.values(Action).some((action) =>
          permissions.includes(buildPermission(Resource.NOTE, action)),
        ) ||
          isSuperAdmin) && {
          label: "Parcourir les notes",
          icon: "ti ti-checklist",
          submenu: false,
          showSubRoute: false,
          link: routes.allNotes,
          themeSetting: true,
        },
        (Object.values(Action).some((action) =>
          permissions.includes(buildPermission(Resource.DIPLOME, action)),
        ) ||
          isSuperAdmin) && {
          label: "Décisions / Diplômes",
          icon: "ti ti-file-text",
          submenu: false,
          showSubRoute: false,
          link: routes.decisionList,
          themeSetting: true,
        },
        ([
          // UE (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
          ...Object.values(Action).map((action) =>
            buildPermission(Resource.UE, action),
          ),

          // matières (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
          ...Object.values(Action).map((action) =>
            buildPermission(Resource.SUBJECT, action),
          ),

          // evaluation (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
          ...Object.values(Action).map((action) =>
            buildPermission(Resource.EVALUATION, action),
          ),
        ].some((p) => permissions.includes(p)) ||
          isSuperAdmin) && {
          label: "Unité d'Enseignements",
          icon: "ti ti-school",
          submenu: true,
          showSubRoute: false,
          submenuItems: [
            ([
              // UE (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
              ...Object.values(Action).map((action) =>
                buildPermission(Resource.UE, action),
              ),
            ].some((p) => permissions.includes(p)) ||
              isSuperAdmin) && {
              label: "Créer une UE",
              link: routes.ue,
            },
            // map chaque actions avec la ressource et verifie si un de ces mappage est dans les permissions de l'utilisateur
            (Object.values(Action).some((action) =>
              permissions.includes(
                buildPermission(Resource.EVALUATION, action),
              ),
            ) ||
              isSuperAdmin) && {
              label: "Matières Évalués",
              link: routes.evaluationList,
            },
          ].filter(Boolean),
        },
      ].filter(Boolean),
    },
    // Paramètres
    ([
      // utilisateur (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.USER, action),
      ),

      // année universitaire (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.ACADEMIC_YEAR, action),
      ),

      // periode d'évaluation (map chaque actions avec la ressource et nous renvoie les éléments du tableau obtenu)
      ...Object.values(Action).map((action) =>
        buildPermission(Resource.EVAL_PERIOD, action),
      ),
    ].some((p) => permissions.includes(p)) ||
      isSuperAdmin) && {
      label: "Paramètres",
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: "Peoples",
      submenuItems: [
        // map chaque actions avec la ressource et verifie si un de ces mappage est dans les permissions de l'utilisateur
        (Object.values(Action).some((action) =>
          permissions.includes(
            buildPermission(Resource.CALCULATION_METHODS, action),
          ),
        ) ||
          isSuperAdmin) && {
          label: "Paramètres Généraux",
          link: routes.settings,
          icon: "ti ti-adjustments",
          submenu: false,
          showSubRoute: false,
          themeSetting: true,
        },
        (Object.values(Action).some((action) =>
          permissions.includes(buildPermission(Resource.USER, action)),
        ) ||
          isSuperAdmin) && {
          label: "Personnel Administratif",
          icon: "ti ti-user-cog",
          submenu: false,
          showSubRoute: false,
          link: routes.allUser,
          subLink1: routes.editUser,
          subLink2: routes.newUser,
          subLink3: routes.rolesPermissions,
          themeSetting: true,
        },
        // map chaque actions avec la ressource et verifie si un de ces mappage est dans les permissions de l'utilisateur
        // (Object.values(Action).some((action) =>
        //   permissions.includes(buildPermission(Resource.ACADEMIC_YEAR, action))
        // ) ||
        //   isSuperAdmin) && {
        //   label: "Années Universitaires",
        //   icon: "ti ti-calendar-time",
        //   submenu: false,
        //   showSubRoute: false,
        //   link: routes.academicYear,
        //   themeSetting: true,
        // },
        // map chaque actions avec la ressource et verifie si un de ces mappage est dans les permissions de l'utilisateur
        // (Object.values(Action).some((action) =>
        //   permissions.includes(buildPermission(Resource.EVAL_PERIOD, action))
        // ) ||
        //   isSuperAdmin) && {
        //   label: "Période d'Évaluation",
        //   icon: "ti ti-clipboard-check",
        //   submenu: false,
        //   showSubRoute: false,
        //   link: routes.evaluationPeriod,
        //   themeSetting: true,
        // },
      ].filter(Boolean),
    },
  ].filter(Boolean);

  const parentProfilSections: any[] = [
    {
      label: "ACCUEIL",
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: "Main",
      submenuItems: [
        {
          label: "Tableau de Bord",
          icon: "ti ti-calendar",
          submenu: false,
          showSubRoute: false,
          link: parent_route.parentDashboard,
          themeSetting: true,
        },
      ],
    },
    {
      label: "Espace Universitaire",
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: "Main",
      submenuItems: [
        {
          label: "Emplois du Temps",
          icon: "ti ti-calendar",
          submenu: false,
          showSubRoute: false,
          link: parent_route.studentEDT,
          themeSetting: true,
        },
        {
          label: "Cours",
          icon: "ti ti-book",
          submenu: false,
          showSubRoute: false,
          link: parent_route.studentCourse,
          themeSetting: true,
        },
        {
          label: "Cours de Rattrapages",
          icon: "ti ti-repeat",
          submenu: false,
          showSubRoute: false,
          link: parent_route.studentCourse,
          themeSetting: true,
        },
        {
          label: "Notes",
          icon: "ti ti-file-text",
          submenu: false,
          showSubRoute: false,
          link: parent_route.studentNote,
          themeSetting: true,
        },
        {
          label: "Absences",
          icon: "ti ti-user-x",
          submenu: false,
          showSubRoute: false,
          link: parent_route.studentAttendance,
          themeSetting: true,
        },
      ],
    },
  ];

  const studentProfilSections: any[] = [
    {
      label: "ACCUEIL",
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: "Main",
      submenuItems: [
        {
          label: "Tableau de Bord",
          icon: "ti ti-calendar",
          submenu: false,
          showSubRoute: false,
          link: student_route.studentDashboard,
          themeSetting: true,
        },
      ],
    },
    {
      label: "Espace Universitaire",
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: "Main",
      submenuItems: [
        {
          label: "Emplois du Temps",
          icon: "ti ti-calendar",
          submenu: false,
          showSubRoute: false,
          link: student_route.studentEDT,
          themeSetting: true,
        },
        {
          label: "Mes Cours",
          icon: "ti ti-book",
          submenu: false,
          showSubRoute: false,
          link: student_route.studentCourse,
          themeSetting: true,
        },
        // {
        //   label: "Cours de Rattrapages",
        //   icon: "ti ti-repeat",
        //   submenu: false,
        //   showSubRoute: false,
        //   link: student_route.studentCourse,
        //   themeSetting: true,
        // },
        {
          label: "Mes Notes",
          icon: "ti ti-file-text",
          submenu: false,
          showSubRoute: false,
          link: student_route.studentNote,
          themeSetting: true,
        },
        {
          label: "Mes Absences",
          icon: "ti ti-user-x",
          submenu: false,
          showSubRoute: false,
          link: student_route.studentAttendance,
          themeSetting: true,
        },
      ],
    },
  ];

  const teacherProfilSections: any[] = [
    {
      label: "Espace Universitaire",
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: "Main",
      submenuItems: [
        {
          label: "Emplois du Temps",
          icon: "ti ti-calendar",
          submenu: false,
          showSubRoute: false,
          link: prof_route.teacherEDT,
          themeSetting: true,
        },
        {
          label: "Mes Cours",
          icon: "ti ti-book",
          submenu: false,
          showSubRoute: false,
          link: prof_route.teacherCourse,
          themeSetting: true,
        },
        {
          label: "Cours de Rattrapages",
          icon: "ti ti-repeat",
          submenu: false,
          showSubRoute: false,
          link: student_route.studentCourse,
          themeSetting: true,
        },
        {
          label: "Mes Notes",
          icon: "ti ti-file-text",
          submenu: false,
          showSubRoute: false,
          link: student_route.studentNote,
          themeSetting: true,
        },
        {
          label: "Mes Absences",
          icon: "ti ti-user-x",
          submenu: false,
          showSubRoute: false,
          link: student_route.studentAttendance,
          themeSetting: true,
        },
      ],
    },
  ];

  // ajout de la dashbord de base
  // sidebarData.push({
  //   label: "ACCUEIL",
  //   submenuOpen: true,
  //   showSubRoute: false,
  //   submenuHdr: "Main",
  //   submenuItems: [
  //     {
  //       label: "Tableau de bord",
  //       icon: "ti ti-layout-dashboard",
  //       submenu: false,
  //       showSubRoute: false,
  //       link: dashboardLink,
  //       themeSetting: true,
  //     },
  //   ],
  // });

  // Ajoute des sections liées au type  d'utilisateur (profil)
  switch (userType) {
    case "UserProfil":
      sidebarData.push(...userProfilSections);
      break;
    case "ParentProfil":
      sidebarData.push(...parentProfilSections);
      break;
    case "StudentProfil":
      sidebarData.push(...studentProfilSections);
      break;
    case "TeacherProfil":
      sidebarData.push(...teacherProfilSections);
      break;
    default:
      // Aucun profil ou profil inconnu, rien à ajouter
      break;
  }
  return sidebarData;
};

const routes = my_routes;

export const SidebarData = [
  // Accueil
  {
    label: "ACCUEIL",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Main",
    submenuItems: [
      {
        label: "Tableau de bord",
        icon: "ti ti-layout-dashboard",
        submenu: false,
        showSubRoute: false,
        link: routes.adminDashboard,
        themeSetting: true,
      },
    ],
  },
  // Acteurs Académiques
  {
    label: "Acteurs Académiques",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Peoples",

    submenuItems: [
      {
        label: "Étudiants",
        icon: "ti ti-school",
        submenu: true,
        showSubRoute: false,

        submenuItems: [
          { label: "Liste des Étudiants", link: routes.allStudent },
          { label: "Inscrire un Étudiant", link: routes.registrationStudent },
          // {
          //   label: "Ré-inscrire un Étudiant",
          //   link: routes.reSTUDENTStudent,
          // },
        ],
      },
      {
        label: "Parents",
        icon: "ti ti-user-bolt",
        showSubRoute: false,
        submenu: false,
        link: routes.allParent,
      },
      {
        label: "Professeurs",
        icon: "ti ti-users",
        submenu: false,
        showSubRoute: false,
        link: routes.allTeacher,
        subLink1: routes.createTeacher,
        themeSetting: true,
      },
      // Élements pédagogiques
      {
        label: "Élements pédagogiques",
        icon: "ti ti-users",
        submenu: true,
        showSubRoute: false,

        submenuItems: [
          { label: "Niveaux", link: routes.levelList },
          { label: "Classes", link: routes.classList },
          { label: "Matières", link: routes.subjectList },
          { label: "Salles (Locaux)", link: routes.classroomList },
        ],
      },
    ],
  },
  // Gestion des Notes
  {
    label: "Gestion des Notes",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Peoples",

    submenuItems: [
      {
        label: "Parcourir les notes",
        icon: "ti ti-layout-sidebar",
        submenu: false,
        showSubRoute: false,
        link: routes.allNotes,
        themeSetting: true,
      },
      {
        label: "Notes Externes",
        icon: "ti ti-layout-sidebar",
        submenu: false,
        showSubRoute: false,
        link: routes.noteExterne,
        themeSetting: true,
      },
      {
        label: "Unité d'Enseignements",
        icon: "ti ti-school",
        submenu: true,
        showSubRoute: false,

        submenuItems: [
          { label: "Créer une UE", link: routes.ue },
          { label: "Évaluations", link: routes.evaluationList },
        ],
      },
    ],
  },
  // Paramètres
  {
    label: "Paramètres",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Peoples",

    submenuItems: [
      {
        label: "Paramètres Principaux",
        icon: "ti ti-school",
        submenu: true,
        showSubRoute: true,

        submenuItems: [
          { label: "Général", link: routes.settings },
          {
            label: "Années Universitaires",
            link: routes.academicYear,
            themeSetting: true,
          },
          {
            label: "Période d'Évaluation",
            link: routes.evaluationPeriod,
            themeSetting: true,
          },
        ],
      },
      {
        label: "Personnel Administratif",
        icon: "ti ti-layout-sidebar",
        submenu: false,
        showSubRoute: false,
        link: routes.allUser,
        subLink1: routes.editUser,
        subLink2: routes.newUser,
        subLink3: routes.rolesPermissions,
        themeSetting: true,
      },
    ],
  },
];
